<template>
  <a-spin :spinning="loading">
    <div class="spin-content">
      <a-tabs defaultActiveKey="1">
        <a-tab-pane tab="FILTROS" key="1">
          <a-card>
            <a-form :form="formCargar" @submit="cargarEmpleados">
              <a-row :gutter="16" type="flex" align="middle">
                <a-col :xs="24" :sm="24" :md="6" :lg="5">
                  <g-dropdown endpoint="hierarchy_lookup"
                              :decorator="['grupo', decoradores.valor_requerido]"
                              :formItemConfig="{label:'Grupo', 'label-col': {span: 6}, 'wrapper-col': {span: 18}}"
                              :params="grupoParams"
                              :selectedObj.sync="grupoSeleccionado"
                              @change="grupoCambiado"></g-dropdown>
                </a-col>
                <a-col :xs="24" :sm="24" :md="6" :lg="5">
                  <g-dropdown endpoint="hierarchy_lookup"
                              :decorator="['puesto', decoradores.valor_requerido]"
                              :formItemConfig="{label:'Puesto', 'label-col': {span: 6}, 'wrapper-col': {span: 18}}"
                              :selectedObj.sync="puestoSeleccionado"
                              :params="puestoParams"></g-dropdown>
                </a-col>
                <a-col :xs="24" :sm="24" :md="8" :lg="8">
                  <a-form-item label="Rango de fechas" :label-col="{span: 8}" :wrapper-col="{span: 16}">
                    <a-range-picker
                      v-model="selectedRange"
                      :disabled-date="disabledDate"
                      format="YYYY-MM-DD"
                      @change="rangoFechasCambiado"
                      style="width: 100%;"
                    />
                  </a-form-item>
                </a-col>
                <a-col :xs="24" :sm="24" :md="4" :lg="4">
                  <a-form-item :wrapper-col="{span: 24}" style="margin-bottom: 0;">
                    <a-button type="primary" html-type="submit">Cargar</a-button>
                  </a-form-item>
                </a-col>
              </a-row>
            </a-form>
          </a-card>
          &nbsp;
          <a-table
            size="small"
            :columns="columns"
            :dataSource="empleados"
            :pagination="false"
            rowKey="id_emp"
            :scroll="{ x: tableScrollX, y: 500 }"
          >
            <sh-input
              :slot="'itemRender'+(columna-1)"
              slot-scope="text, record, fila"
              v-for="columna in totalDias"
              :key="columna"
              :horasTrabajadas="empleados[fila].config[columna-1].horasTrabajadas"
              :horasEsperadas="empleados[fila].config[columna-1].horasEsperadas"
              :estadoCumplimiento="empleados[fila].config[columna-1].estadoCumplimiento"
              :estadoMarcacion="empleados[fila].config[columna-1].estadoMarcacion"
              :festivo="empleados[fila].config[columna-1].esFestivo"
              :domingo="empleados[fila].config[columna-1].esDomingo"
              :horasExtras="empleados[fila].config[columna-1].horasExtras"
              :horasFaltantes="empleados[fila].config[columna-1].horasFaltantes"
              :horasRecargoNocturno="empleados[fila].config[columna-1].horasRecargoNocturno"
              :horasRecargoFestivoDiurno="empleados[fila].config[columna-1].horasRecargoFestivoDiurno"
              :horasRecargoFestivoNocturno="empleados[fila].config[columna-1].horasRecargoFestivoNocturno"
              :saldoDia="empleados[fila].config[columna-1].saldoDia"
              :fechaHoraInicio="empleados[fila].config[columna-1].fechaHoraInicio"
              :fechaHoraFin="empleados[fila].config[columna-1].fechaHoraFin"
              :marcaciones="empleados[fila].config[columna-1].marcacionesDia || []"
              :turnoProgramado="empleados[fila].config[columna-1].turnoProgramado"
              :tieneTurnoProgramado="!!(empleados[fila].config[columna-1].scheduleId || empleados[fila].config[columna-1].turnoId)"
              @click="abrirModalAgregarTurno(empleados[fila], fila, columna - 1)"
              @edit="abrirModalEditarTurno(empleados[fila], fila, columna - 1)"
              @delete="eliminarTurno(empleados[fila], fila, columna - 1)"
            />
            <span slot="nombreRenderer" slot-scope="text, record, index" class="nombre-empleado-cell">
              <div class="nombre-empleado-block">
                <span class="nombre-empleado">{{ text }}</span>
                <span class="cargo-empleado" v-if="record.cargo">{{ record.cargo }}</span>
              </div>
              <span class="horas-resumen">
                <strong class="horas-programadas">{{ formatHorasDecimalToHhMm(record.totalHorasEsperadas) }}h</strong>
                <span class="separador">/</span>
                <strong class="horas-laboradas">{{ formatHorasDecimalToHhMm(record.totalHorasTrabajadas) }}h</strong>
              </span>
            </span>

            <div
              slot="filterDropdown"
              slot-scope="{ setSelectedKeys, selectedKeys, confirm, clearFilters, column }"
              style="padding: 8px">
              <a-input
                v-ant-ref="c => (searchInput = c)"
                :placeholder="`Buscar ${column.dataIndex}`"
                :value="selectedKeys[0]"
                style="width: 188px; margin-bottom: 8px; display: block;"
                @change="e => setSelectedKeys(e.target.value ? [e.target.value] : [])"
                @pressEnter="() => handleSearch(selectedKeys, confirm, column.dataIndex)"
              />
              <a-button
                type="primary"
                icon="search"
                size="small"
                style="width: 90px; margin-right: 8px"
                @click="() => handleSearch(selectedKeys, confirm, column.dataIndex)">
                Buscar
              </a-button>
              <a-button size="small" style="width: 90px" @click="() => handleReset(clearFilters)">
                Reset
              </a-button>
            </div>
            <a-icon
              slot="filterIcon"
              slot-scope="filtered"
              type="search"
              :style="{ color: filtered ? '#108ee9' : undefined }"
            />
            <template slot="customRender" slot-scope="text, record, index, column">
              <span v-if="searchText && searchedColumn === column.dataIndex">
                <template
                  v-for="(fragment, i) in text
                    .toString()
                    .split(new RegExp(`(?<=${searchText})|(?=${searchText})`, 'i'))">
                  <mark
                    v-if="fragment.toLowerCase() === searchText.toLowerCase()"
                    :key="i"
                    class="highlight">
                    {{ fragment }}
                  </mark>
                  <template v-else>{{ fragment }}</template>
                </template>
              </span>
              <template v-else>
                {{ text }}
              </template>
            </template>
          </a-table>

          <!-- Modal Agregar turno -->
          <a-modal
            :visible="modalAgregarTurnoVisible"
            @ok="guardarTurno"
            @cancel="cerrarModalAgregarTurno"
            :title="isEditModeTurno ? 'Editar turno' : 'Agregar turno'"
            width="520px"
            :confirmLoading="loading"
            :maskClosable="!loading"
            okText="Guardar"
          >
            <a-form layout="vertical" :rules="formRules" :model="formTurno" ref="formAgregarTurno">
              <a-row :gutter="16">
                <a-col :span="24">
                  <a-form-item label="Turno">
                    <a-select
                      :value="turnoSelectValue"
                      placeholder="Seleccione un turno"
                      allow-clear
                      show-search
                      option-filter-prop="children"
                      style="width: 100%"
                      @change="onTurnoSelectChange"
                    >
                      <a-select-option
                        v-for="opt in turnoOptions"
                        :key="opt.value"
                        :value="opt.value"
                      >
                        {{ opt.text }}
                      </a-select-option>
                    </a-select>
                  </a-form-item>
                </a-col>
                <a-col :span="24">
                  <a-form-item label="Fecha">
                    <a-input :value="fechaTurnoDisplay" disabled />
                  </a-form-item>
                </a-col>
                <a-col :span="12">
                  <a-form-item label="Hora programada entrada" prop="horaEntrada" :required="true">
                    <a-time-picker
                      v-model="formTurno.horaEntrada"
                      format="HH:mm"
                      valueFormat="HH:mm"
                      style="width: 100%"
                    />
                  </a-form-item>
                </a-col>
                <a-col :span="12">
                  <a-form-item label="Hora programada salida" prop="horaSalida" :required="true">
                    <a-time-picker
                      v-model="formTurno.horaSalida"
                      format="HH:mm"
                      valueFormat="HH:mm"
                      style="width: 100%"
                    />
                  </a-form-item>
                </a-col>
                <a-col :span="24">
                  <a-form-item>
                    <a-checkbox v-model="formTurno.turnoPartido">
                      Turno partido
                    </a-checkbox>
                  </a-form-item>
                </a-col>
                <template v-if="formTurno.turnoPartido">
                  <a-col :span="12">
                    <a-form-item label="Hora entrada (partido)" prop="horaEntradaPartido" :required="formTurno.turnoPartido">
                      <a-time-picker
                        v-model="formTurno.horaEntradaPartido"
                        format="HH:mm"
                        valueFormat="HH:mm"
                        style="width: 100%"
                      />
                    </a-form-item>
                  </a-col>
                  <a-col :span="12">
                    <a-form-item label="Hora salida (partido)" prop="horaSalidaPartido" :required="formTurno.turnoPartido">
                      <a-time-picker
                        v-model="formTurno.horaSalidaPartido"
                        format="HH:mm"
                        valueFormat="HH:mm"
                        style="width: 100%"
                      />
                    </a-form-item>
                  </a-col>
                </template>
                <a-col :span="24">
                  <a-form-item label="Comentario">
                    <a-textarea
                      v-model="formTurno.comentario"
                      placeholder="Ingrese el comentario"
                      :rows="3"
                    />
                  </a-form-item>
                </a-col>
                <a-col :span="24">
                  <a-form-item label="Cantidad de horas">
                    <a-input
                      v-model="formTurno.nHours"
                      placeholder="Ej: 8"
                    />
                  </a-form-item>
                </a-col>
              </a-row>
            </a-form>
          </a-modal>
        </a-tab-pane>
      </a-tabs>
    </div>
  </a-spin>
</template>

<script>
import HttpUtil from '@/util/HttpUtil'
import Mensajes from 'CustomModules/GlobalBPOCore/Util/Mensajes'

export default {
  data () {
    return {
      loading: false,
      selectedRange: [],
      selectedStartDate: null,
      selectedEndDate: null,
      grupoSeleccionado: {},
      puestoSeleccionado: {},
      formCargar: this.$form.createForm(this, {
        name: 'frmCargarHoras'
      }),
      decoradores: {
        valor_requerido: {rules: [{required: true, message: 'Valor requerido'}]}
      },
      columns: [],
      empleados: [],
      totalDias: 0,
      searchText: '',
      searchedColumn: '',
      searchInput: null,
      can_view_groups: this.$getConfigValue('CAN_VIEW_GROUPS', 'NO') === 'SI',
      modalAgregarTurnoVisible: false,
      isEditModeTurno: false,
      empleadoSeleccionado: null,
      columnaSeleccionada: null,
      formTurno: {
        turnoSeleccionado: null,
        horaEntrada: null,
        horaSalida: null,
        turnoPartido: false,
        horaEntradaPartido: null,
        horaSalidaPartido: null,
        comentario: '',
        nHours: ''
      },
      turnoOptions: [],
      turnoSelectValue: undefined,
      formRules: {}
    }
  },
  mounted () {
    this.http = new HttpUtil()
    this.initDataTable()
    this.initFormRules()
  },
  methods: {
    initFormRules () {
      const self = this
      this.formRules = {
        horaEntrada: [{
          required: true,
          message: 'Hora programada de entrada es requerida'
        }],
        horaSalida: [{
          required: true,
          message: 'Hora programada de salida es requerida'
        }],
        horaEntradaPartido: [{
          validator (rule, value, callback) {
            if (self.formTurno.turnoPartido && !value) {
              // eslint-disable-next-line standard/no-callback-literal
              callback('Hora de inicio del turno partido es requerida')
            } else {
              callback()
            }
          }
        }],
        horaSalidaPartido: [{
          validator (rule, value, callback) {
            if (self.formTurno.turnoPartido && !value) {
              // eslint-disable-next-line standard/no-callback-literal
              callback('Hora de fin del turno partido es requerida')
            } else {
              callback()
            }
          }
        }]
      }
    },
    handleSearch (selectedKeys, confirm, dataIndex) {
      confirm()
      this.searchText = selectedKeys[0]
      this.searchedColumn = dataIndex
    },
    handleReset (clearFilters) {
      clearFilters()
      this.searchText = ''
    },
    rangoFechasCambiado (dates) {
      const [startDate, endDate] = dates
      this.selectedStartDate = startDate ? startDate.format('YYYY-MM-DD 00:00:00') : null
      this.selectedEndDate = endDate ? endDate.format('YYYY-MM-DD 00:00:00') : null
      this.initDataTable()
    },
    refetchHorasProgramadas () {
      if (!this.selectedStartDate || !this.selectedEndDate) {
        return Promise.resolve()
      }
      const grupoVal = (this.grupoSeleccionado && this.grupoSeleccionado.value) !== undefined ? this.grupoSeleccionado.value : this.formCargar.getFieldValue('grupo')
      const puestoVal = (this.puestoSeleccionado && this.puestoSeleccionado.value) !== undefined ? this.puestoSeleccionado.value : this.formCargar.getFieldValue('puesto')
      return this.http.getInstance().get('ct/consultar_horas_programadas', {
        params: {
          rango_start_date: this.selectedStartDate,
          rango_end_date: this.selectedEndDate,
          grupo: grupoVal,
          puesto: puestoVal
        }
      }).then((response) => {
        this.procesarRespuesta(response.data)
      }).catch((error) => {
        console.error('Error refetching scheduled hours:', error)
        Mensajes.error('Error', 'No fue posible actualizar los datos en pantalla.')
        throw error
      })
    },
    cargarEmpleados (e) {
      e.preventDefault()
      if (this.loading) {
        return
      }

      this.formCargar.validateFields((err, values) => {
        if (!err) {
          if (!this.selectedStartDate || !this.selectedEndDate) {
            Mensajes.warning('Advertencia', 'Debe seleccionar un rango de fechas.')
            return
          }

          this.loading = true
          this.empleados.splice(0, this.empleados.length)

          this.http.getInstance().get('ct/consultar_horas_programadas', {
            params: {
              rango_start_date: this.selectedStartDate,
              rango_end_date: this.selectedEndDate,
              grupo: values.grupo,
              puesto: values.puesto
            }
          }).then((response) => {
            this.procesarRespuesta(response.data)
          }).catch((error) => {
            console.error('Error loading scheduled hours:', error)
            Mensajes.error('Error', 'No fue posible cargar las horas programadas, contacte a mesa de ayuda.')
          }).finally(() => {
            this.loading = false
          })
        }
      })
    },
    procesarRespuesta (data) {
      const empleadosData = data.empleados || []
      const festivos = (data.festivos || []).map(f => moment(f, 'YYYY-MM-DD HH:mm:ss').format('YYYY-MM-DD'))

      const startDate = moment(this.selectedStartDate)
      const endDate = moment(this.selectedEndDate)
      const diasEnRango = endDate.diff(startDate, 'days') + 1
      const domingosPorMes = {}
      for (let fecha = startDate.clone(); fecha.isBefore(endDate) || fecha.isSame(endDate); fecha.add(1, 'day')) {
        if (fecha.day() === 0) {
          const claveMes = fecha.format('YYYY-MM')
          if (!domingosPorMes[claveMes]) {
            domingosPorMes[claveMes] = []
          }
          domingosPorMes[claveMes].push(fecha.date())
        }
      }

      this.empleados = empleadosData.map((empleado) => {
        const configArray = {}
        let totalHorasTrabajadas = 0
        let totalHorasEsperadas = 0

        for (let idx = 0; idx < diasEnRango; idx++) {
          const fechaColumna = startDate.clone().add(idx, 'days')
          const fechaColumnaStr = fechaColumna.format('YYYY-MM-DD')
          const configDia = empleado.config && empleado.config[idx] !== undefined
            ? empleado.config[idx]
            : (empleado.config ? Object.values(empleado.config).find(
                (config) => this.normalizarFechaConfig(config.fecha_turno) === fechaColumnaStr
              ) : null)

          const mesDelDia = fechaColumna.format('YYYY-MM')
          const diaDelMes = fechaColumna.date()
          const esDomingo = (domingosPorMes[mesDelDia] || []).includes(diaDelMes)
          const esFestivo = festivos.includes(fechaColumnaStr)

          if (configDia) {
            const horasTrabajadas = parseFloat(configDia.horas_trabajadas_dia) || 0
            const horasEsperadas = parseFloat(configDia.horas_esperadas_dia) || 0

            totalHorasTrabajadas += horasTrabajadas
            totalHorasEsperadas += horasEsperadas

            configArray[idx] = {
              fecha: fechaColumnaStr,
              horasTrabajadas: horasTrabajadas,
              horasEsperadas: horasEsperadas,
              estadoCumplimiento: configDia.estado_cumplimiento,
              estadoMarcacion: configDia.estado_marcacion,
              horasExtras: parseFloat(configDia.horas_extras_dia) || 0,
              horasFaltantes: parseFloat(configDia.horas_faltantes_dia) || 0,
              horasRecargoNocturno: parseFloat(configDia.horas_recargo_nocturno) || 0,
              horasRecargoFestivoDiurno: parseFloat(configDia.horas_recargo_festivo_dom_diurno) || 0,
              horasRecargoFestivoNocturno: parseFloat(configDia.horas_recargo_festivo_dom_nocturno) || 0,
              saldoDia: parseFloat(configDia.saldo_dia) || 0,
              fechaHoraInicio: configDia.fecha_hora_inicio,
              fechaHoraFin: configDia.fecha_hora_fin,
              esDomingo: configDia.es_domingo === 'S' || esDomingo,
              esFestivo: configDia.es_festivo === 'S' || esFestivo,
              marcacionesDia: configDia.marcaciones_dia || [],
              turnoProgramado: configDia.turno_programado || '',
              scheduleId: configDia.id || null,
              turnoId: configDia.id_rh_t_shifts_setup != null ? String(configDia.id_rh_t_shifts_setup) : null,
              startTimeProgramado: configDia.start_time || null,
              endTimeProgramado: configDia.final_time || null,
              comments: configDia.comments || '',
              nHours: (configDia.n_hours != null ? String(configDia.n_hours) : (configDia.approved_hours != null ? String(configDia.approved_hours) : '')),
              usarTurnoPartido: !!configDia.usar_turno_partido || configDia.split_shift === 'SI',
              startDateShiftMatch: configDia.start_date_shift_match || null,
              endDateShiftMatch: configDia.end_date_shift_match || null
            }
          } else {
            configArray[idx] = {
              fecha: fechaColumnaStr,
              horasTrabajadas: 0,
              horasEsperadas: 0,
              estadoCumplimiento: null,
              estadoMarcacion: null,
              horasExtras: 0,
              horasFaltantes: 0,
              horasRecargoNocturno: 0,
              horasRecargoFestivoDiurno: 0,
              horasRecargoFestivoNocturno: 0,
              saldoDia: 0,
              fechaHoraInicio: null,
              fechaHoraFin: null,
              esDomingo,
              esFestivo,
              marcacionesDia: [],
              turnoProgramado: ''
            }
          }
        }

        return {
          ...empleado,
          config: configArray,
          totalHorasTrabajadas: totalHorasTrabajadas.toFixed(2),
          totalHorasEsperadas: totalHorasEsperadas.toFixed(2)
        }
      })

      this.initDataTable()
      this.$nextTick(() => this.$forceUpdate())
    },
    initDataTable () {
      this.columns.splice(0, this.columns.length)

      this.columns.push({
        title: 'Empleado',
        dataIndex: 'nombre',
        key: 'nombre',
        fixed: 'left',
        width: 380,
        scopedSlots: {
          filterDropdown: 'filterDropdown',
          filterIcon: 'filterIcon',
          customRender: 'nombreRenderer'
        },
        onFilter: (value, record) =>
          record.nombre
            .toString()
            .toLowerCase()
            .includes(value.toLowerCase()),
        onFilterDropdownVisibleChange: visible => {
          if (visible) {
            setTimeout(() => {
              this.searchInput.focus()
            }, 0)
          }
        }
      })

      if (this.selectedStartDate && this.selectedEndDate) {
        const startDate = moment(this.selectedStartDate)
        const endDate = moment(this.selectedEndDate)
        const diasEnRango = endDate.diff(startDate, 'days') + 1
        this.totalDias = diasEnRango

        for (let i = 0; i < diasEnRango; i++) {
          const date = startDate.clone().add(i, 'days')
          this.columns.push({
            title: date.format('DD') + ' ' + date.format('ddd'),
            dataIndex: `config[${i}]`,
            scopedSlots: {customRender: `itemRender${i}`},
            width: 80
          })
        }
      } else {
        this.totalDias = 0
      }
    },
    disabledDate (current) {
      return current && current.year() > moment().year()
    },
    grupoCambiado () {
      this.formCargar.setFieldsValue({
        puesto: undefined
      })
    },
    abrirModalAgregarTurno (empleado, fila, columna) {
      this.empleadoSeleccionado = empleado
      this.columnaSeleccionada = columna
      this.resetFormTurno()
      this.modalAgregarTurnoVisible = true
    },
    cerrarModalAgregarTurno () {
      this.modalAgregarTurnoVisible = false
      this.isEditModeTurno = false
      this.empleadoSeleccionado = null
      this.columnaSeleccionada = null
      this.resetFormTurno()
    },
    abrirModalEditarTurno (empleado, fila, columna) {
      const configDia = empleado.config && empleado.config[columna]
      if (!configDia || (!configDia.scheduleId && !configDia.fechaHoraInicio && !configDia.turnoProgramado)) {
        Mensajes.warning('Advertencia', 'No hay datos de turno para editar en este día.')
        return
      }
      this.empleadoSeleccionado = empleado
      this.columnaSeleccionada = columna
      this.isEditModeTurno = true
      this.resetFormTurno()
      const horaEntrada = this.parseTimeFromConfig(configDia.startTimeProgramado || configDia.fechaHoraInicio)
      const horaSalida = this.parseTimeFromConfig(configDia.endTimeProgramado || configDia.fechaHoraFin)
      this.formTurno = {
        turnoSeleccionado: configDia.turnoId ? { value: configDia.turnoId } : null,
        horaEntrada: horaEntrada,
        horaSalida: horaSalida,
        turnoPartido: !!configDia.usarTurnoPartido,
        horaEntradaPartido: this.parseTimeFromConfig(configDia.startDateShiftMatch),
        horaSalidaPartido: this.parseTimeFromConfig(configDia.endDateShiftMatch),
        comentario: configDia.comments || '',
        nHours: configDia.nHours != null ? configDia.nHours : ''
      }
      this.turnoSelectValue = configDia.turnoId || undefined
      this.modalAgregarTurnoVisible = true
    },
    /**
     * Convierte horas decimales (p. ej., 8.5 = 8h30m) al formato de visualización HH.MM, que coincide con Oracle RH_F_HHMM_TO_DECIMAL_FORMAT.
     * Se usa solo para visualización; los totales se calculan con valores decimales.
     *
     * @param {string|number} decimalHours - Horas como decimal (fracción = fracción de hora)
     * @returns {string} - Formato de visualización HH.MM (p. ej., "8.30")
     */
    formatHorasDecimalToHhMm (decimalHours) {
      if (decimalHours == null || decimalHours === '') return '0'

      const n = Number(decimalHours)

      if (Number.isNaN(n)) return '0'

      let vHh = Math.trunc(n)
      let decimalPart = n - vHh
      // let vMm = Math.round((n - vHh) * 60)
      let vMm = Math.round((decimalPart + Number.EPSILON) * 60)

      if (vMm === 60) {
        vHh += 1
        vMm = 0
      }
      // return vHh + '.' + String(vMm).padStart(2, '0')
      return `${vHh}.${String(vMm).padStart(2, '0')}`
    },
    normalizarFechaConfig (fechaTurno) {
      if (fechaTurno == null || fechaTurno === '') return null
      const m = moment(fechaTurno, ['YYYY-MM-DD HH:mm:ss', 'YYYY-MM-DD'], true)
      if (m.isValid()) return m.format('YYYY-MM-DD')
      const str = String(fechaTurno)
      if (/^\d{4}-\d{2}-\d{2}/.test(str)) return str.substring(0, 10)
      return null
    },
    parseTimeFromConfig (dateTimeStr) {
      if (!dateTimeStr) return null
      const m = moment(dateTimeStr)
      if (!m.isValid()) return null
      return m.format('HH:mm')
    },
    resetFormTurno () {
      this.turnoSelectValue = undefined
      this.formTurno = {
        turnoSeleccionado: null,
        horaEntrada: null,
        horaSalida: null,
        turnoPartido: false,
        horaEntradaPartido: null,
        horaSalidaPartido: null,
        comentario: '',
        nHours: ''
      }
    },
    loadTurnoOptions () {
      this.http.getInstance().get('shift_setup/dropdown')
        .then((response) => {
          const data = response.data
          this.turnoOptions = (data && data.data) ? data.data : (Array.isArray(data) ? data : [])
        })
        .catch(() => {
          this.turnoOptions = []
        })
    },
    onTurnoSelectChange (value) {
      this.turnoSelectValue = value
      if (value === undefined || value === null || value === '') {
        this.formTurno.turnoSeleccionado = null
        return
      }
      const opt = this.turnoOptions.find((o) => String(o.value) === String(value))
      this.formTurno.turnoSeleccionado = opt ? { value: opt.value, text: opt.text } : null
    },
    combineDateAndTime (dateStr, timeStr) {
      if (!dateStr || !timeStr) return null
      const time = typeof timeStr === 'string' ? timeStr : (timeStr && timeStr.format ? timeStr.format('HH:mm') : '')
      return `${dateStr} ${time}:00`
    },
    guardarTurno () {
      if (!this.empleadoSeleccionado || this.columnaSeleccionada === null) {
        return
      }
      const configDia = this.empleadoSeleccionado.config[this.columnaSeleccionada]
      const fechaStr = configDia.fecha
      if (!fechaStr) {
        Mensajes.error('Error', 'No se pudo obtener la fecha de la celda.')
        return
      }
      const turnoId = this.formTurno.turnoSeleccionado && this.formTurno.turnoSeleccionado.value
      if (!turnoId) {
        Mensajes.error('Error', 'Seleccione un turno.')
        return
      }
      const horaEntrada = this.formTurno.horaEntrada && (typeof this.formTurno.horaEntrada === 'string' ? this.formTurno.horaEntrada : this.formTurno.horaEntrada.format ? this.formTurno.horaEntrada.format('HH:mm') : null)
      const horaSalida = this.formTurno.horaSalida && (typeof this.formTurno.horaSalida === 'string' ? this.formTurno.horaSalida : this.formTurno.horaSalida.format ? this.formTurno.horaSalida.format('HH:mm') : null)
      if (!horaEntrada || !horaSalida) {
        Mensajes.error('Error', 'La hora programada de entrada y salida son requeridas.')
        return
      }
      if (this.formTurno.turnoPartido) {
        const horaEntradaPartido = this.formTurno.horaEntradaPartido && (typeof this.formTurno.horaEntradaPartido === 'string' ? this.formTurno.horaEntradaPartido : this.formTurno.horaEntradaPartido.format ? this.formTurno.horaEntradaPartido.format('HH:mm') : null)
        const horaSalidaPartido = this.formTurno.horaSalidaPartido && (typeof this.formTurno.horaSalidaPartido === 'string' ? this.formTurno.horaSalidaPartido : this.formTurno.horaSalidaPartido.format ? this.formTurno.horaSalidaPartido.format('HH:mm') : null)
        if (!horaEntradaPartido || !horaSalidaPartido) {
          Mensajes.error('Error', 'Cuando el turno es partido, la hora de inicio y fin del turno partido son requeridas.')
          return
        }
      }

      const fecha = new Date(fechaStr)
      const year = fecha.getFullYear()
      const month = fecha.getMonth() + 1
      const periodCalculated = Math.ceil(fecha.getDate() / 15)
      const period = periodCalculated === 1 ? 2 : periodCalculated === 2 ? 4 : periodCalculated

      let startDateTime = this.combineDateAndTime(fechaStr, horaEntrada)
      let endDateTime = this.combineDateAndTime(fechaStr, horaSalida)

      const [entradaHora, entradaMin] = horaEntrada.split(':').map(Number)
      const [salidaHora, salidaMin] = horaSalida.split(':').map(Number)
      const entradaMinutos = entradaHora * 60 + entradaMin
      const salidaMinutos = salidaHora * 60 + salidaMin
      if (salidaMinutos <= entradaMinutos) {
        const fechaSiguiente = moment(fechaStr, 'YYYY-MM-DD').add(1, 'days').format('YYYY-MM-DD')
        endDateTime = this.combineDateAndTime(fechaSiguiente, horaSalida)
      }

      const scheduleId = this.isEditModeTurno && configDia && configDia.scheduleId ? configDia.scheduleId : null
      const scheduleData = {
        id: scheduleId,
        id_emp: this.empleadoSeleccionado.id_emp,
        start_time: startDateTime,
        final_time: endDateTime,
        comments: this.formTurno.comentario || '',
        n_hours: this.formTurno.nHours || null,
        year: year,
        month: month,
        period: period,
        id_rh_t_shifts_setup: turnoId,
        usar_turno_partido: !!this.formTurno.turnoPartido
      }

      if (this.formTurno.turnoPartido && this.formTurno.horaEntradaPartido && this.formTurno.horaSalidaPartido) {
        const horaEntradaPartido = typeof this.formTurno.horaEntradaPartido === 'string' ? this.formTurno.horaEntradaPartido : this.formTurno.horaEntradaPartido.format ? this.formTurno.horaEntradaPartido.format('HH:mm') : null
        const horaSalidaPartido = typeof this.formTurno.horaSalidaPartido === 'string' ? this.formTurno.horaSalidaPartido : this.formTurno.horaSalidaPartido.format ? this.formTurno.horaSalidaPartido.format('HH:mm') : null
        if (horaEntradaPartido && horaSalidaPartido) {
          let startPartido = this.combineDateAndTime(fechaStr, horaEntradaPartido)
          let endPartido = this.combineDateAndTime(fechaStr, horaSalidaPartido)
          const [epH, epM] = horaEntradaPartido.split(':').map(Number)
          const [spH, spM] = horaSalidaPartido.split(':').map(Number)
          if (spH * 60 + spM <= epH * 60 + epM) {
            const fechaSiguiente = moment(fechaStr, 'YYYY-MM-DD').add(1, 'days').format('YYYY-MM-DD')
            endPartido = this.combineDateAndTime(fechaSiguiente, horaSalidaPartido)
          }
          scheduleData.start_date_shift_match = startPartido
          scheduleData.end_date_shift_match = endPartido
        }
      }

      this.loading = true
      return this.http.getInstance().post('weekly_schedule/batch_update', { schedules: [scheduleData] })
        .then((response) => {
          if (response.data.success) {
            const msg = this.isEditModeTurno ? 'Turno actualizado exitosamente.' : 'Turno guardado exitosamente.'
            Mensajes.success('Correcto', msg)
            this.cerrarModalAgregarTurno()
            return this.refetchHorasProgramadas()
          }
        })
        .catch((error) => {
          const errorMessage = this.$getErrorMessage ? this.$getErrorMessage(error, 'No fue posible guardar el turno.') : (error.response && error.response.data && error.response.data.message) || 'No fue posible guardar el turno.'
          Mensajes.error('Error', errorMessage)
          throw error
        })
        .finally(() => {
          this.loading = false
        })
    },
    eliminarTurno (empleado, fila, columna) {
      const configDia = empleado.config && empleado.config[columna]

      if (!configDia) {
        Mensajes.error('Error', 'No se pudo obtener la información de la celda, contacte a mesa de ayuda.')
        return
      }

      this.loading = true
      return this.http.getInstance().post('cth/eliminar_turno', {
        start_time: configDia.startTimeProgramado,
        final_time: configDia.endTimeProgramado,
        id_emp: empleado.id_emp,
        grupo: this.grupoSeleccionado.value,
        puesto: this.puestoSeleccionado.value
      }).then((response) => {
        Mensajes.success('Correcto', 'Registro eliminado exitosamente.')
        return this.refetchHorasProgramadas()
      }).catch((error) => {
        let errorMessage = this.$getErrorMessage(error, 'No fue posible eliminar el turno, contacte a mesa de ayuda.')
        Mensajes.error('Error', errorMessage)
      }).finally(() => {
        this.loading = false
      })
    }
  },
  watch: {
    modalAgregarTurnoVisible (visible) {
      if (visible) {
        this.loadTurnoOptions()
      }
    }
  },
  computed: {
    tableScrollX () {
      const colEmpleadoWidth = 380
      const colDiaWidth = 80
      const totalWidth = colEmpleadoWidth + this.totalDias * colDiaWidth
      return totalWidth > 0 ? totalWidth : undefined
    },
    fechaTurnoDisplay () {
      if (!this.empleadoSeleccionado || this.columnaSeleccionada === null) return ''
      const configDia = this.empleadoSeleccionado.config[this.columnaSeleccionada]
      return configDia && configDia.fecha ? configDia.fecha : ''
    },
    grupoParams () {
      return {h_lookup_type: 'ID_H_ATT1', custom_handler: 'grupo_lleno', can_view_groups: this.can_view_groups}
    },
    puestoParams () {
      return {
        h_lookup_type: 'ID_H_ATT2',
        custom_handler: 'puesto_lleno',
        id_h_lookup_father: this.grupoSeleccionado.value ? this.grupoSeleccionado.value : -1
      }
    }
  }
}
</script>

<style scoped>
.nombre-empleado-cell {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 4px;
}

.nombre-empleado-block {
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.nombre-empleado {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.cargo-empleado {
  font-size: 12px;
  color: #8c8c8c;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.horas-resumen {
  display: inline-flex;
  align-items: center;
  margin-left: 8px;
  padding: 2px 8px;
  /*background-color: #2c3e50;*/
  border-radius: 4px;
  font-size: 12px;
  white-space: nowrap;
}

.horas-programadas {
  color: #3498db;
}

.separador {
  color: #95a5a6;
  margin: 0 4px;
}

.horas-laboradas {
  color: #2ecc71;
}

.highlight {
  background-color: #ffc069;
  padding: 0;
}

.marcaciones-dia-section {
  margin-top: 16px;
}

.marcaciones-dia-title {
  margin-bottom: 8px;
  font-size: 14px;
  font-weight: 600;
}
</style>



// WEBPACK FOOTER //
// src/customization/GlobalBPOCore/pages/ShiftsManagement/ScheduledHours.vue